import axios from 'axios'

import store from '@/store'
import { removeCookie } from '@/utils/cookies.js'

const endpoint = '/api'

const pass = data => data

const checkErr = (resp) => {
  if (resp.status === 403) {
    store.state.router.push('/login')
    throw new Error(`Not logged in.`)
  }
  // API does not exist, when CTF just begined
  if (resp.status === 404) {
    return { err: '', msg: '' }
  }

  // TODO:
  // Use different handlers on different statuses
  if (resp.status >= 300) throw new Error(`Request failed with status code ${resp.status}`)

  const data = resp.data
  if (data.err) {
    if (data.err === 'nologin') {
      return store.state.router.push('/login')
    }
    throw new Error(`${data.err}: ${data.msg}`)
  }

  return data
}

const requestOptions = {
  // Make 400s response could be handled
  validateStatus: status => (status >= 200 && status < 300) || (status >= 400 && status < 500)
}

const makeGetRequest = (url, cb) => axios.get(url, requestOptions)
  .then(checkErr)
  .then(cb || pass)

const makePostRequest = (url, data, cb) => {
  if (data.toString() !== '[object FormData]') {
    const fd = new FormData()
    for (let i in data) {
      fd.append(i, data[i])
    }
    data = fd
  }
  return axios.post(url, data, requestOptions)
    .then(checkErr)
    .then(cb || pass)
}

const info = () => makeGetRequest(`${endpoint}/info`)
const passwd = (uid, pass, newpass) => makePostRequest(`${endpoint}/passwd`, {uid, pass, newpass})
const newTeam = (name) => makePostRequest(`${endpoint}/new_team`, {name})
const trend = () => makeGetRequest(`${endpoint}/trend`)
const rank = () => makeGetRequest(`${endpoint}/rank`)
const top = () => makeGetRequest(`${endpoint}/top`)
const news = () => makeGetRequest(`${endpoint}/news`)
const register = (uid, pass, email) => makePostRequest(`${endpoint}/register`, {uid, pass, email})
const login = (uid, pass) => makePostRequest(`${endpoint}/login`, {uid, pass})
const challenge = pid => makeGetRequest(`${endpoint}/challenge/query?pid=${pid}`)
const submit = (pid, flag) => makePostRequest(`${endpoint}/challenge/submit_flag`, {pid, flag})
const list = () => makeGetRequest(`${endpoint}/challenge/list`)
const team = tid => makeGetRequest(`${endpoint}/team?tid=${tid}`)
const joinTeam = token => makePostRequest(`${endpoint}/join_team`, {token})
const profile = () => makeGetRequest(`${endpoint}/profile`)
const uploadLogo = fd => makePostRequest(`${endpoint}/upload_logo`, fd)
const forgetPwd = (email, prefix) => makePostRequest(`${endpoint}/forget_pwd`, {email, prefix})
const logout = () => {
  removeCookie('sig')
  removeCookie('uid')
  store.commit('setProfile', {
    uid: '',
    token: '',
    email: ''
  })
  store.state.router.push('/login')
}

export {
  passwd, newTeam, trend, rank, news,
  register, login, challenge, submit,
  list, team, top, joinTeam, profile, uploadLogo,
  logout, info, forgetPwd
}



// WEBPACK FOOTER //
// ./src/utils/api.js